import React, { FC } from 'react';
import { AccountItem } from '../AccountItem/AccountItem';

const titles = {
    title: i18next.t('TableHead.titles.title'),
    account_number: i18next.t('TableHead.titles.account_number'),
    user_bind: {
        name: i18next.t('TableHead.titles.user_bind'),
    },
    current_balance: i18next.t('TableHead.titles.current_balance'),
    currency: {
        title: i18next.t('TableHead.titles.currency'),
    },
    default_account: i18next.t('TableHead.titles.default_account'),
};

export const TableHead = () => {
    return <AccountItem account={titles} isHead={true} />;
};
